import React from 'react';
import { SelectionContent } from './SelectionContent';
import { TabContainer } from './Tabs';
import { NoProjectFound } from './NoProjectFound';
import { Project, SelectItem } from '../../../types';
import { LoadingPage } from '../../Shared';
import { SearchBox } from '../Search';
import { useThemeContext } from '../../../context';
import * as Constants from '../../../utils/constants';

export interface ProjectSelectionProps {
  tabConfigured: boolean;
  selectTab: (projectType: string) => void;
  onSearch: (input: string) => void;
  onClear: () => void;
  onChange: (input: string) => void;
  tabId: string;
  loading: boolean;
  projectSelectionItems: SelectItem[];
  project: Project;
  searchValue?: string;
  filterValue?: string;
  tabs: { id: string; text: string; projectType: string }[];
}

export function ProjectSelection({
  tabConfigured,
  selectTab,
  tabId,
  loading,
  projectSelectionItems,
  project,
  onSearch,
  onChange,
  onClear,
  searchValue,
  filterValue,
  tabs,
}: ProjectSelectionProps): JSX.Element {
  const theme = useThemeContext();

  let searchBoxPlaceholder = 'Enter filter criteria';
  let noProjectsMessage = 'No projects found.';
  let inputValue = filterValue;
  let isFilterBox = true;

  if (tabId === 'searched') {
    searchBoxPlaceholder = 'Enter search criteria';
    if (!searchValue) {
      noProjectsMessage = 'Enter search criteria to begin searching.';
    }
    inputValue = searchValue;
    isFilterBox = false;
  }

  return (
    <div
      id='ProjectSelection'
      style={{
        display: 'inline-flex',
        width: '100%',
        flexDirection: 'column',
      }}
    >
      <TabContainer
        tabs={tabs}
        currentTabId={tabId}
        setCurrentTabId={selectTab}
      />
      <SearchBox
        placeholder={searchBoxPlaceholder}
        onClear={onClear}
        onSearch={onSearch}
        onChange={onChange}
        inputValue={inputValue}
        isFilterBox={isFilterBox}
        theme={theme}
      />
      {loading ? (
        <LoadingPage subtext='Searching for your projects...' />
      ) : projectSelectionItems && projectSelectionItems.length ? (
        <SelectionContent
          tabConfigured={tabConfigured}
          items={projectSelectionItems}
          selected={project.id}
          projectName={project.name}
          isPw365Project={
            project.solutionType === Constants.SolutionTypes.projectWise365
          }
        />
      ) : (
        <NoProjectFound message={noProjectsMessage} />
      )}
    </div>
  );
}
